/* import __COLOCATED_TEMPLATE__ from './notifications.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const Notifications = templateOnlyComponent<Signature>();
export default Notifications;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::LeftNav::Notifications': typeof Notifications;
    'inbox2/left-nav/notifications': typeof Notifications;
  }
}
